module.exports = __webpack_public_path__ + "static/media/404.4df92e05.svg";